import script from "./TariffSelectNumberDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TariffSelectNumberDialog.vue?vue&type=script&setup=true&lang=js"

import "./TariffSelectNumberDialog.vue?vue&type=style&index=0&id=70b1051a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b1051a"]])

export default __exports__